import React from 'react';
import styled from 'styled-components';
import {
    Image
} from 'UI-Dash-Commons-UI';
import {
    SectionContainer,
    SectionHeaderLogoWrapper,
    SectionWrapper
} from './SectionStyles';

const BottomGraphic = require('../images/screen4-bottom-graphics.png');
const BottomGraphicAltText = 'bottomImage';
const BottomGraphicWidth = '132px';
const BottomGraphicHeight = '127px';

const TopGraphic = require('../images/screen4-topgraphics.png');
const TopGraphicAltText = 'topImage';
const TopGraphicWidth = '110px';
const TopGraphicHeight = '110px';

const SectionLogo = require('../images/screen4-applovin-logo-white.svg');
const SectionLogoAltText = 'logo';
const SectionLogoWidth = '170px';
const SectionLogoHeight = '32px';

const SectionHeaderText = 'Grow your business with our full-stack monetization solution.';
const ButtonText = 'Get started today!';

type Section4Props = {
    onClick: () => void;
}

const Section4: React.FunctionComponent<Section4Props> =
    (
        {
            onClick,
        }
    ) =>
    {
        const onGettingStarted = () =>
        {
            window.open( '/documentation/mediation/max/get-started-with-max' );
            onClick();
        };

        return <StyledSectionContainer>
            <SectionWrapper>
                <StyledSectionTopImageWrapper>
                    <Image
                        alt={TopGraphicAltText}
                        src={TopGraphic}
                        width={TopGraphicWidth}
                        height={TopGraphicHeight}
                    />
                </StyledSectionTopImageWrapper>
                <StyledSectionHeaderLogoWrapper>
                    <Image
                        alt={SectionLogoAltText}
                        src={SectionLogo}
                        width={SectionLogoWidth}
                        height={SectionLogoHeight}
                    />
                </StyledSectionHeaderLogoWrapper>
                <StyledSectionHeader>
                    {SectionHeaderText}
                </StyledSectionHeader>
                <SectionButtonWrapper>
                    <GetStartedButton
                        onClick={onGettingStarted}
                    >
                        {ButtonText}
                    </GetStartedButton>
                </SectionButtonWrapper>
                <StyledSectionBottomImageWrapper>
                    <Image
                        alt={BottomGraphicAltText}
                        src={BottomGraphic}
                        width={BottomGraphicWidth}
                        height={BottomGraphicHeight}
                    />
                </StyledSectionBottomImageWrapper>
            </SectionWrapper>
        </StyledSectionContainer>;
    }
;

const StyledSectionContainer = styled( SectionContainer )`
    background: linear-gradient( to top, ${props => props.theme.colors.backgroundBlueDark} 100% 100% );
`;

const StyledSectionTopImageWrapper = styled.div`
    margin: -8px 270px 4px 20px;
`;

const StyledSectionBottomImageWrapper = styled.div`
    position: absolute;
    height: 114px;
    bottom: 0;
    right: 0;
    overflow: hidden;
    border-bottom-right-radius: 12px;
`;

const StyledSectionHeaderLogoWrapper = styled( SectionHeaderLogoWrapper )`
    margin: 0px 115px;
`;

const StyledSectionHeader = styled.div`
    margin: 32px 35px;
    font-family: ${props => props.theme.fonts.light};
    color: ${props => props.theme.colors.white};
    text-align: center;
    font-size: 32px;
    line-height: 44px;
`;

const SectionButtonWrapper = styled.div`
    display:flex;
    justify-content: center;
`;

const GetStartedButton = styled.a`
    display: inline-block;
    position: relative;
    height: 64px;
    
    width: 235px;
    
    color: ${props => props.theme.colors.blueVivid};
    background: ${props => props.theme.colors.white};
    border: none;
    border-radius: 6px;
    text-decoration: none;
    font-family: ${props => props.theme.fonts.black};
    font-size: 20px;
    line-height: 64px;
    text-align:center;
    transition: 0.2s opacity linear;
    
    box-shadow: 10px 8px #84D0E8;
    
    &:hover {
        box-shadow: 10px 8px ${props => props.theme.colors.blueVivid};
    }
`;

export default Section4;
